module.exports = __webpack_public_path__ + "pr31.jpg?b464a57fa93530c4fd7f14002d8af9cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pr31.jpg
// module id = 73
// module chunks = 0